import {
  generateKey,
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  _pick,
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
const posts = {
  state: {
    list_post: [],
    one_post: {},
    new_post: {},
    total: 0,
    count: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    getList(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/posts/getListForSpa";
      if (!payload.search) delete payload.search;
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            let { list, count, total } = res.data;
            list = list.map((e) => {
              if (e.langContent && typeof e.langContent === "string") {
                try {
                  e.langContent = JSON.parse(e.langContent);
                } catch (err) {}
              }
              return e;
            });
            _this.setState({ list_post: list, total: total, count: count });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
    },
    create(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/posts/create";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            let list_post = rootState.posts.list_post;
            list_post.push(res.data);
            _this.setState({ new_post: res.data, list_post: list_post });
          }
          return res;
        })
        .catch((error) => {
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    update(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/posts/update";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(
          _pick(payload, [
            "featureImage",
            "content",
            "title",
            "description",
            "categories",
            "tags",
            "isPublish",
            "slug",
            "lang",
            "langContent",
          ])
        ),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ one_post: res.data });

            if (payload.snackbar) {
              payload.snackbar("Update success", "success");
            }
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    getBySlug(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/posts/getBySlugForSpa";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          slug: payload.slug,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ one_post: res.data });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    delete(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/posts/delete";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          _id: payload._id,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            if (payload.snackbar) {
              payload.snackbar("Delete success", "success");
            }
            _this.getList();
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
  }),
};

export default posts;
